<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{}">
      <validation-provider
        v-slot="{ errors }"
        :name="fieldName"
        :rules="rules"
      >
        <v-text-field
          ref="input"
          v-model="_value"
          color="blue"
          :disabled="disabled"
          :hide-details="hideDetails"
          :error-messages="errors"
          :label="$t('fields.'+fieldName)"
          :autofocus="autofocus"
          :class="classSelf"
          :style="styleSelf"
          v-on="$listeners"
          @blur="blur"
          @keydown="onlyLetters"
        >
          <template v-slot:append>
            <v-btn
              small
              tabindex="-1"
              icon
              @click="openDialog"
            >
              <v-icon v-text="'$calendar'" />
            </v-btn>
          </template>
        </v-text-field>
      </validation-provider>
    </template>
    <v-date-picker
      v-model="picker_value"
      no-title
      :locale="datepicker_settings.locale"
      :first-day-of-week="datepicker_settings.first_day_of_week"
      :events="events"
      :event-color="eventColor"
      @input="menu = false, _value = picker_value, $refs.input.focus()"
    />
  </v-menu>
</template>

<script>
  import { format, parse, isValid, add } from 'date-fns'
  import { sync } from 'vuex-pathify'
  const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'

  export default {
    name: 'DateField',
    model: {
      prop: 'dateValue',
      event: 'valuechange',
    },
    props: {
      dateValue: String,
      fieldName: String,
      rules: String,
      disabled: Boolean,
      autofocus: {
        type: Boolean,
        default: false,
      },
      dateFormat: {
        type: String,
        default: DEFAULT_DATE_FORMAT,
      },
      events: {
        type: Array,
        default () { return [] },
      },
      eventColor: {
        type: String,
        default: 'green',
      },
      classSelf: {
        type: String,
        default: '',
      },
      styleSelf: {
        type: String,
        default: '',
      },
      hideDetails: {
        type: Boolean,
        default: false,
      },
    },
    data: vm => ({
      menu: false,
      picker_value: null,
    }),
    computed: {
      _value: {
        get: function () {
          return this.dateValue
        },
        set: function (value) {
          // console.log(value.replace(/[^\d|:]/g, ''))
          this.$emit('valuechange', value)
        },
      },
      datepicker_settings: sync('app/datepicker_settings'),
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month}-${day}`
      },
      parseDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      Down (element) {
        // this.value = '2021-03-02'
        console.log('LE')
      },
      Up () {
        console.log('FEL')
      },
      blur (e) {
        console.log(this._value)
        let value = this._value ?? ''
        if (value.length !== 10) {
          switch (value.length) {
            case 1:
            case 2:
              value = format(new Date(), 'yyyyMM') + value.padStart(2, '0')
              break
            case 3:
            case 4:
              value = new Date().getFullYear() + value.padStart(4, '0')
              break
            case 6:
              if (parseInt(value.substr(0, 2)) < 50) {
                value = '20' + value
              } else {
                value = '19' + value
              }
              break
          }
          const date = parse(value, 'yyyyMMdd', new Date())
          if (isValid(date)) {
            // console.log('valid_date')
            // console.log(date)
            value = format(date, this.dateFormat)
            this._value = value !== '' ? value : null
          } else {
            // console.log('Üres!!!')
            this._value = ''
          }
        }
      },
      onlyLetters (e) {
        console.log(this._value)
        const value = (this._value ?? '').replace(/[-./]/g, '')
        const selector = this.$refs.input.$el.querySelector('input')
        const selectionStart = selector.selectionStart
        const selectionEnd = selector.selectionEnd
        const length = value.length

        const date = parse(value, 'yyyyMMdd', new Date())
        // console.log('Parsolás kész')
        // console.log(isValid(date))

        // console.log(moment('00:00', 'HH:mm').format('HH:mm'))
        // console.log(moment('00:00', 'HH:mm').isValid())
        if ([33, 34, 38, 40].indexOf(e.keyCode) !== -1) {
          if (isValid(date)) {
            // console.log('A')
            switch (e.keyCode) {
              case 33:
                this._value = format(add(date, { months: 1 }), this.dateFormat)
                break
              case 34:
                this._value = format(add(date, { months: -1 }), this.dateFormat)
                break
              case 38:
                this._value = format(add(date, { days: 1 }), this.dateFormat)
                break
              case 40:
                this._value = format(add(date, { days: -1 }), this.dateFormat)
                break
            }
          } else if (value === '') {
            // console.log('B')
            this._value = format(new Date(), this.dateFormat)
          } else {
            // console.log('C')
          }

          e.preventDefault()
          return
        }

        // Allow: Numbers
        if (
          ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(e.key) !== -1 &&
          (length < 8 || selectionStart !== selectionEnd)
        ) {
          return
        }

        if (
          // (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(e.key) !== -1) ||
          // Allow: Numbers
          (e.key === '-' && this._value.split('-').length <= 2) ||
          // Allow: first [:]
          [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
          // Allow: Ctrl+A
          (e.keyCode === 65 && e.ctrlKey === true) ||
          // Allow: Ctrl+C
          (e.keyCode === 67 && e.ctrlKey === true) ||
          // Allow: Ctrl+V
          (e.keyCode === 86 && e.ctrlKey === true) ||
          // Allow: Ctrl+X
          (e.keyCode === 88 && e.ctrlKey === true) ||
          // Allow: home, end, up, down, left, right
          (e.keyCode >= 35 && e.keyCode <= 40)) {
          // let it happen, don't do anything
          return
        }

        // Ensure that it is other and stop the keypress
        e.preventDefault()
      },
      openDialog () {
        const date = parse(this._value, 'yyyy-MM-dd', new Date())
        if (isValid(date)) {
          this.picker_value = this._value
        } else {
          this.picker_value = null
        }
        this.menu = !this.menu
      },
    },
  }
</script>
